import Header from "./Header";
import Body from "./Body";

const Weatherapp = ()=>{
    return (
        <div className="bg-[url('https://i.pinimg.com/564x/48/93/00/4893007a48c9d8642ec855e0896780aa.jpg')] w-full h-screen opacity-95">
            <Header/>
            <Body/>
            
        </div>
    )
}

export default Weatherapp;
